<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-show="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="modal-dialog" :class="modalClass">
            <div class="modal-content">

              <!--Header-->
              <div class="modal-header">
                <slot name="header">
                  <div class="modal-title">
                    <slot v-if="currentDocument != null" name="title">

                      {{$t('companyModal.title',
                      {
                      'number': currentDocument.position,
                      'date': currentFormattedDate
                      })}}

                    </slot>
                  </div>

                  <span aria-hidden="true" class="ion ion-ios-arrow-back" @click="prevDocument"></span>
                  {{currentDocumentIndex + 1 + "/" + documents.length}}
                  <span aria-hidden="true" class="ion ion-ios-arrow-forward" @click="nextDocument"></span>
                  <i
                    class="ion ion-md-close close-modal"
                    v-if="closeIconShown"
                    @click.prevent="cancel"
                  />

                </slot>
              </div>
              <!--Container-->
              <div class="modal-body">
                <div v-if="currentDocument != null"
                     slot="title">

                </div>
                <div>
                  <img width="70%"
                       :src="this.currentDocumentFile"/>
                </div>

                <div v-if="currentDocument != null" class="checkbox-cell">

                  <div>

                    <checkbox-cell
                      name="original"
                      :initialValue="!!currentDocument.hasOriginal"
                      :rowData="currentDocument"
                      :onChange="onChange">

                      {{'companyModal.original' | translate}}
                    </checkbox-cell>

                  </div>

                  <div>
                    <checkbox-cell
                      name="print"
                      :initialValue="!!currentDocument.isPrinted"
                      :rowData="currentDocument"
                      :onChange="onChange"
                    >{{'companyModal.printed' | translate}}
                    </checkbox-cell>

                  </div>

                  <div class="date-cell">

                    <date-cell
                      name="date"
                      :rowData="currentDocument"
                      :onChange="onChange"
                    >{{'companyModal.printed' | translate}}
                    </date-cell>

                  </div>

                  <div class="text-cell">

                    <text-cell

                      :onChange="onChange"
                      :rowData="currentDocument">
                      {{currentDocument.notes}}
                    </text-cell>
                  </div>

                </div>

              </div>
              <!--Footer-->
              <div class="modal-footer">
                <slot name="footer">
                  <button type="button" v-if="!noButtons" :class="okClass"
                          @click="ok" :disabled="okDisabled">
                    {{ okText }}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import { host } from '../../services/http'
import { Debounce } from '../companies/details/utils'
import { documentsApi } from '../../services/api/documentsApi'

export default {
  name: 'company-document-preview',
  props: {
    documents: {
      type: Array
    },

    startDocumentIndex: {
      type: Number
    },

    transition: {
      type: String,
      default: 'modal',
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    force: {
      type: Boolean,
      default: false,
    },
    okText: {
      type: String,
      default: 'CONFIRM',
    },
    cancelText: {
      type: String,
      default: 'CANCEL',
    },
    okClass: {
      type: String,
      default: 'btn btn-primary',
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary',
    },
    closeIconShown: {
      type: Boolean,
      default: true,
    },
    okDisabled: {
      type: Boolean,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    noButtons: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      show: false,
      duration: 500,
      currentDocumentIndex: this.startDocumentIndex
    }
  },

  mounted: function () {
    this.debouncer = new Debounce(1000)
  },

  computed: {
    modalClass () {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small,
      }
    },

    currentDocument: {
      cache: false,
      get () {
        return this.documents[this.currentDocumentIndex]
      }
    },

    currentFormattedDate: function () {
      return moment(this.currentDocument.documentDate).format('DD-MM-YYYY')
    },

    currentDocumentFile: function () {
      return this.currentDocument ? `${host}${this.currentDocument.file}` : ''
    }
  },
  created () {
    if (this.show) {
      document.body.className += ' modal-open'
    }
  },
  beforeDestroy () {
    document.body.className = document.body.className.replace(/\s?modal-open/, '')
  },
  watch: {
    show (value) {
      if (value) {
        document.body.className += ' modal-open'
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(/\s?modal-open/, '')
        }, this.duration)
      }
    },
  },
  methods: {
    onChange (data) {
      let payload = {
        companyId: this.currentDocument.parent,
        docId: this.currentDocument.id,
        attribute: data.name,
        value: data.value
      }

      this.debouncer.run(() => {
        this.saveDocument(payload)
      })
    },

    prevDocument () {
      this.currentDocumentIndex = Math.max(0, this.currentDocumentIndex - 1)
    },

    nextDocument () {
      this.currentDocumentIndex = Math.min(this.documents.length - 1, this.currentDocumentIndex + 1)
    },

    saveDocument: async function (data) {
      documentsApi.update({
        ...data,
        attribute: 'notes'
      })
    },

    listenKeyUp (event) {
      if (event.key === 'Escape') {
        this.cancel()
      }
    },
    ok () {
      this.$emit('ok')
      this.show = false
      window.removeEventListener('keyup', this.listenKeyUp)
    },
    cancel () {
      this.$emit('cancel')
      this.show = false
      window.removeEventListener('keyup', this.listenKeyUp)
    },
    clickMask () {
      if (!this.force) {
        this.cancel()
      }
    },
    open () {
      this.show = true
      window.addEventListener('keyup', this.listenKeyUp)
    },
    close () {
      this.show = false
      window.removeEventListener('keyup', this.listenKeyUp)
    },
  },
}
</script>

<style lang="scss">
  //Modals
  $modal-header-padding-x: $widget-padding;
  $modal-header-padding-y: 0;
  $modal-header-height: $widget-header-height;
  $modal-header-border: $widget-header-border;
  $modal-content-border-width: 0;
  $modal-content-border-radius: 0;
  $modal-inner-padding: 25px;
  $modal-footer-btns-padding-bottom: 20px;
  $modal-footer-btns-margin-x: 10px;
  $modal-md: 650px;
  $modal-lg: 850px;

  .vuestic-modal {
    height: 0;
    width: 0;

    // For Transitioning
    .modal {
      display: block;
    }

    .modal-dialog, .modal-backdrop {
      transition: all .5s ease;
    }

    .modal-enter .modal-dialog, .modal-leave-active .modal-dialog {
      opacity: 0;
      transform: translateY(-30%);
    }

    .modal-enter .modal-backdrop, .modal-leave-active .modal-backdrop {
      opacity: 0;
    }

    .modal-backdrop {
      opacity: 0.5;
    }

    //Modal styles

    .modal-header {
      height: $modal-header-height;
      padding: $modal-header-padding-y $modal-header-padding-x;
      border-bottom: $modal-header-border;
      font-size: $font-size-larger;
      display: flex;
      align-items: center;
    }

    .close-modal {
      margin-left: 1rem;
      font-size: $font-size-large;
      line-height: $font-size-large;
      cursor: pointer;
    }

    .modal-content {
      border-radius: $modal-content-border-radius;
    }

    .modal-footer {
      justify-content: center;
      padding: 0 $modal-inner-padding;
      padding-bottom: calc(#{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom});
      flex-wrap: wrap;

      .btn {
        margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom $modal-footer-btns-margin-x;
      }
    }

    .modal-dialog {
      box-shadow: $modal-content-box-shadow-sm-up;
    }
  }
</style>
